/**
 * brandTheme — resuelve la marca activa a una clave de tema para `data-brand`.
 * Mapa fijo por `businesses.brand` / `cajero.activeBusinessBrand` (FASE 1A).
 * NO consulta DB ni businesses.config. Fallback seguro: celmaxx.
 */

export type BrandTheme = 'celmaxx' | 'gtide' | 'voltum'

/**
 * Normaliza el brand (p. ej. 'G-TiDE' → 'GTIDE', 'VOLTuM' → 'VOLTUM') y lo mapea.
 */
export function resolveBrandTheme(brand: string | null | undefined): BrandTheme {
  const b = (brand ?? '').toUpperCase().replace(/[^A-Z]/g, '')
  if (b === 'GTIDE') return 'gtide'
  if (b === 'VOLTUM') return 'voltum'
  return 'celmaxx'
}
